import API from '../..';
const ENTITY = 'panels-companies';

export const addPanel = (data) =>
    API.post(`/api/v1/${ENTITY}/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
export const bulkPanels = (data) =>
    API.put(`/api/v1/panels/bulk-status/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
export const deletePanel = (id) => API.delete(`/api/v1/${ENTITY}/${id}/`);
export const exportFile = () =>
    API.get(`/api/v1/${ENTITY}/export-upload/`, {
        headers: { 'Content-Type': 'text/csv' },
    });
export const filterPanels = ({
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
    status = 'active',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            search: searchText,
            sort: sortBy,
            status_flag: status,
        },
    });
export const importFile = (data) =>
    API.post(`/api/v1/${ENTITY}/export-upload/`, data);
